// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, createRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SpringSystem } from 'rebound';

export class SpringScrollbars extends Component {
  constructor(props, ...rest) {
    super(props, ...rest);
    this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
    this.scrollbars = createRef();
  }

  componentDidMount() {
    this.springSystem = new SpringSystem();
    this.spring = this.springSystem.createSpring();
    this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
  }

  componentWillUnmount() {
    this.springSystem.deregisterSpring(this.spring);
    this.springSystem.removeAllListeners();
    this.springSystem = undefined;
    this.spring.destroy();
    this.spring = undefined;
  }

  getScrollTop() {
    return this.scrollbars.current && this.scrollbars.current.getScrollTop();
  }

  scrollTop(top) {
    const scrollTop = this.getScrollTop();

    this.spring.setCurrentValue(scrollTop).setAtRest();
    this.spring.setEndValue(top || 0);
  }

  handleSpringUpdate(spring) {
    const val = spring.getCurrentValue();
    this.scrollbars.current.scrollTop(val);
  }

  getHasVerticalScroll() {
    if (!this.scrollbars.current) {
      return false;
    }

    const scrollHeight = this.scrollbars.current.getScrollHeight();
    const clientHeight = this.scrollbars.current.getClientHeight();

    return scrollHeight >= clientHeight;
  }

  render() {
    return <Scrollbars {...this.props} ref={this.scrollbars} />;
  }
}
